import { EditorStorageService } from '@ssml-editor/core';
import '@ssml-editor/vue';
import { VoiceStorageType } from './voice-storage-type.enum.js';

const VoiceMenuUtils = {
  getProps(editor) {
    return editor.__voiceMenuProps;
  },
  setProps(editor, props) {
    editor.__voiceMenuProps = props;
  },
  async getData(editor) {
    const props = this.getProps(editor);
    if (props) {
      const { databaseName, storageType, storeName, reader } = props;
      if (storageType === VoiceStorageType.LOCAL) {
        const editorStorageService = new EditorStorageService(databaseName);
        return storeName ? await editorStorageService.read(storeName) : void 0;
      } else if (storageType === VoiceStorageType.REMOTE) {
        return await reader?.();
      } else {
        return editor.__voiceMenuData;
      }
    }
  },
  async saveData(editor, databaseName, storageType, storeName, saver, data) {
    if (storageType === VoiceStorageType.LOCAL) {
      const editorStorageService = new EditorStorageService(databaseName);
      return await editorStorageService.save(storeName, data);
    } else if (storageType === VoiceStorageType.REMOTE) {
      return await saver(data);
    } else {
      editor.__voiceMenuData = data;
      return true;
    }
  }
};

export { VoiceMenuUtils };
//# sourceMappingURL=voice-menu-utils.js.map
